import { HStack } from '@cdl/heartbeat-react';
import { useDispatch, useSelector } from 'react-redux';
import { trackChangeLead } from '../../analytics/thunks/track-change-lead.thunk';
import { leadNamesSelector } from '../../ecg/selectors/signal.selectors';
import * as stripActions from '../actions/strip.actions';
import { usePlot } from '../contexts/plot.context';
import { useStrip } from '../hooks/useStrip';
import { isOfTypeChangeLead, squareToPixel } from '../utils/graph.utils';
import { LeadButton } from './LeadButton';

export const LeadButtons: React.FC = () => {
  const dispatch = useDispatch();
  const { leads: displayedLeads, stripId, width: stripWidth } = useStrip();
  const height = squareToPixel(1.4);
  const leads = useSelector(leadNamesSelector);
  const { plotName } = usePlot();

  const dispatchAnalytics = (newLeads: string[], previousLeads: string[]) => {
    if (isOfTypeChangeLead(plotName)) {
      dispatch(trackChangeLead(newLeads, previousLeads, plotName));
    }
  };

  const onSelectLead = (lead: string) => {
    dispatchAnalytics([lead], displayedLeads);
    dispatch(stripActions.update({ stripId, strip: { leads: [lead] } }));
  };

  const onToggleLead = (lead: string) => {
    const leadSet = new Set(displayedLeads);
    if (!leadSet.delete(lead)) {
      leadSet.add(lead);
    }
    dispatchAnalytics(Array.from(leadSet), displayedLeads);
    dispatch(
      stripActions.update({
        stripId,
        strip: { leads: Array.from(leadSet) },
      }),
    );
  };

  const onSelectAll = () => {
    dispatchAnalytics(leads, displayedLeads);
    dispatch(stripActions.update({ stripId, strip: { leads } }));
  };

  const onSelectNone = () => {
    dispatchAnalytics([], leads);
    dispatch(stripActions.update({ stripId, strip: { leads: [] } }));
  };

  if (leads.length < 2) {
    return null;
  }

  return (
    <foreignObject width={stripWidth / 3} height={height}>
      <HStack pt='xs' spacing='xs'>
        {leads.map((lead) => (
          <LeadButton
            key={lead}
            lead={lead}
            selected={displayedLeads.includes(lead)}
            onSelect={() => onSelectLead(lead)}
            onToggle={() => onToggleLead(lead)}
          />
        ))}
        {displayedLeads.length < leads.length && (
          <LeadButton
            lead='All'
            onSelect={onSelectAll}
            onToggle={onSelectNone}
          />
        )}
      </HStack>
    </foreignObject>
  );
};
